import React, { useRef, useState, useMemo, useEffect } from "react";
import clsx from "clsx";
import Calendar from "components/calendar";
import CalendarDrawer from "components/calendar/drawer";
import { timeUtils } from "utils/timeUtil";
import style from "./style.module.scss";
import SoundPromptSettings from "components/soundPromptSettings";
import useStore from "../../../../hooks/useStore";
import { _SPORTS_TYPE } from "../../../../common/constants/sportsConstants";

const MajorContainer = ({
  children,
  page,
  onChangePage,
  count,
  selectedTab,
  setSelectedTab,
  setMajorViewType,
  viewType,
}) => {
  const typeSelectRef = useRef();
  const typeSelectButtonRef = useRef();
  const calendarOpenButtonRef = useRef();
  const [today] = useState(timeUtils.todayYmd());
  const [isOpenWebCalendar, setIsOpenWebCalendar] = useState(false);
  const [currentDate, setCurrentDate] = useState(today);
  const [isSortButtonOpen, toggleSortButton] = useState(false);
  const [sortItem, setSortItem] = useState(viewType);
  const { bannerStore } = useStore();

  const viewTypeText = useMemo(() => {
    if (sortItem === "DEFAULT_VIEW") {
      return "확장형 보기";
    } else if (sortItem === "SPORTS_TYPE_VIEW") {
      return "종목순 보기";
    } else {
      return "시간순 보기";
    }
  }, [sortItem]);

  const onClick = (event) => {
    if (isSortButtonOpen) {
      if (
        typeSelectRef.current &&
        !typeSelectRef.current.contains(event.target)
      ) {
        if (
          typeSelectButtonRef.current &&
          !typeSelectButtonRef.current.contains(event.target)
        ) {
          onClickSortButton();
        }
      }
    }
  };

  useEffect(() => {
    if (isSortButtonOpen) {
      document.addEventListener("click", onClick, true);
    }

    return () => {
      document.removeEventListener("click", onClick, true);
    };
  }, [isSortButtonOpen]);

  const onClickToday = () => {
    setCurrentDate(today);
    onChangePage(today);
    setSelectedTab("ALL");
  };

  const onClickPrev = () => {
    const prev = timeUtils.datePrevOrNext(currentDate, "prev");
    setCurrentDate(prev);
    onChangePage(prev);

    const checkToday = timeUtils.checkDifferenceToday(prev, today);
    let tabName = "ALL";

    if (checkToday < 0) {
      tabName = "FINAL";
    }

    setSelectedTab(tabName);
  };

  const onClickNext = () => {
    const next = timeUtils.datePrevOrNext(currentDate, "next");
    setCurrentDate(next);
    onChangePage(next);

    const checkToday = timeUtils.checkDifferenceToday(next, today);
    let tabName = "ALL";

    if (checkToday < 0) {
      tabName = "FINAL";
    }

    setSelectedTab(tabName);
  };

  const onClickTab = (type) => {
    let label = "전체";

    if (type === "ALL") {
      label = "전체";
    } else if (type === "READY") {
      label = "시작전";
    } else if (type === "PROGRESS") {
      label = "진행중";
    } else if (type === "FINAL") {
      label = "종료";
    }

    setSelectedTab(type);
  };

  const onClickCalendarButton = () => {
    setIsOpenWebCalendar(!isOpenWebCalendar);
  };

  const onClickRefresh = () => {
    onChangePage(currentDate);
  };

  const onChangeCalendarPage = (date) => {
    onChangePage(date);

    const checkToday = timeUtils.checkDifferenceToday(date, today);
    let tabName = "ALL";

    if (checkToday < 0) {
      tabName = "FINAL";
    }

    setSelectedTab(tabName);
  };

  const onClickSortButton = () => {
    toggleSortButton(!isSortButtonOpen);
  };

  const onClickSortItem = (type) => {
    let categoryText = "";
    bannerStore.setFlagMajorType(_SPORTS_TYPE.MAJOR);
    if (type === "DEFAULT_VIEW") {
      categoryText = "확장형 보기";
    } else if (type === "SPORTS_TYPE_VIEW") {
      categoryText = "종목순 보기";
    } else {
      categoryText = "시간순 보기";
    }

    if (isSortButtonOpen) {
      setSortItem(type);
      setMajorViewType(type);
      toggleSortButton(false);
    }
  };

  return (
    <>
      <div className={clsx(style.option_wrap, page === 'home' ? style.table_hide_content : '')}>
        <div className={style.calendar_area}>
          <button
              className={clsx(style.btn_ic, style.btn_prev)}
              onClick={onClickPrev}
          >
            이전
          </button>
          <span className={style.date}>{currentDate.split("-").join(".")}</span>
          <button
              className={clsx(style.btn_ic, style.btn_next)}
              onClick={onClickNext}
          >
            다음
          </button>
          <button
              ref={calendarOpenButtonRef}
              className={clsx(style.btn_bx, style.btn_calendar)}
              onClick={onClickCalendarButton}
          >
            달력
          </button>
          <button
              className={clsx(style.btn_bx, style.btn_today)}
              onClick={onClickToday}
          >
            오늘
          </button>
        </div>
        <div className={style.option_btn_area}>
          {/* <a className={style.btn btn_full" href="">전체모드</a>
      <a className={style.btn btn_small" href="">축소모드</a>
      <a className={style.btn btn_setup" href="">설정</a> */}
          <SoundPromptSettings sportsType="major"/>
          <button
              className={clsx(style.btn, style.btn_refresh)}
              onClick={onClickRefresh}
          >
            새로고침
          </button>
        </div>
        <div className={style.category_area}>
          <ul className={style.tab}>
            <li className={clsx(selectedTab === "ALL" && style.selected)}>
              <button onClick={() => onClickTab("ALL")}>
                전체({count.all})
              </button>
            </li>
            <li className={clsx(selectedTab === "READY" && style.selected)}>
              <button onClick={() => onClickTab("READY")}>
                대기중({count.ready})
              </button>
            </li>
            <li className={clsx(selectedTab === "PROGRESS" && style.selected)}>
              <button onClick={() => onClickTab("PROGRESS")}>
                진행중({count.inProgress})
              </button>
            </li>
            <li className={clsx(selectedTab === "FINAL" && style.selected)}>
              <button onClick={() => onClickTab("FINAL")}>
                종료({count.final})
              </button>
            </li>
          </ul>

          <div className={style.option_area}>
            {/* <select className={style.btn_sort} name="" id="">
              <option value="">종목순 보기</option>
              <option value="">시간순 보기</option>
            </select> */}

            <button
                className={style.btn_sort}
                onClick={onClickSortButton}
                ref={typeSelectButtonRef}
            >
              {viewTypeText}
            </button>
            <ul
                className={clsx(style.list, isSortButtonOpen && style.open)}
                ref={typeSelectRef}
            >
              <li>
                <button
                    className={clsx(sortItem === "TIME_SORT_VIEW" && style.on)}
                    onClick={() => onClickSortItem("TIME_SORT_VIEW")}
                >
                  시간순 보기
                </button>
              </li>
              <li>
                <button
                    className={clsx(sortItem === "DEFAULT_VIEW" && style.on)}
                    onClick={() => onClickSortItem("DEFAULT_VIEW")}
                >
                  확장형 보기
                </button>
              </li>
              <li>
                <button
                    className={clsx(sortItem === "SPORTS_TYPE_VIEW" && style.on)}
                    onClick={() => onClickSortItem("SPORTS_TYPE_VIEW")}
                >
                  종목순 보기
                </button>
              </li>
            </ul>
          </div>
        </div>

        <CalendarDrawer
            transitionclassName="web-calendar-transition"
            isOpen={isOpenWebCalendar}
            closeDrawer={() => setIsOpenWebCalendar(false)}
        >
          <Calendar
              onClickToday={onClickToday}
              currentDate={currentDate}
              onChangePage={onChangeCalendarPage}
              setCurrentDate={setCurrentDate}
              sportsType={"major"}
              closeDrawer={() => setIsOpenWebCalendar(false)}
              calendarOpenButtonRef={calendarOpenButtonRef}
          />
        </CalendarDrawer>
      </div>
      {children}
    </>
  );
};

export default MajorContainer;
